import { Avatar, Dropdown } from 'antd';
import { LogoutOutlined, QuestionCircleOutlined, ShareAltOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useStoredAvatar } from '../../auth/avatarStorage';
import './UserProfile.css';

function getInitials(name: string) {
    return name
        .split(' ')
        .map((part) => part[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();
}

function UserProfile() {
    const { t } = useTranslation(['auth', 'common']);
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const avatar = useStoredAvatar(user);
    const displayName = user?.displayName || user?.email || t('profile.account');
    return (
        <Dropdown
            menu={{
                items: [
                    {
                        key: 'help',
                        icon: <QuestionCircleOutlined />,
                        label: t('nav.help', { ns: 'common' }),
                        onClick: () => navigate('/help'),
                    },
                    {
                        key: 'ecosystem',
                        icon: <ShareAltOutlined />,
                        label: t('nav.ecosystem', { ns: 'common' }),
                        onClick: () => navigate('/ecosystem'),
                    },
                    { type: 'divider' },
                    {
                        key: 'logout',
                        icon: <LogoutOutlined />,
                        label: t('profile.signOut'),
                        onClick: logout,
                    },
                ],
            }}
            trigger={['click']}
        >
            <button
                type="button"
                className="user-profile"
                aria-label={t('profile.openMenu', { name: displayName })}
            >
                <Avatar className="user-profile__avatar" src={avatar || undefined}>
                    {getInitials(displayName)}
                </Avatar>
                <div className="user-profile__meta">
                    <strong className="user-profile__name">{displayName}</strong>
                    <span className="user-profile__role">
                        {user?.email || t('profile.personalAccount')}
                    </span>
                </div>
            </button>
        </Dropdown>
    );
}

export default UserProfile;
